var _path, _path2, _g, _rect, _path3, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoXls(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 93,
    viewBox: "0 0 78 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 5C6 2.23858 8.23858 0 11 0H42.931H48.1285C49.4691 0 50.7535 0.538347 51.6935 1.4942L64.0345 14.0436L76.5256 26.4651C77.4694 27.4035 78 28.6795 78 30.0105V55.8624V88C78 90.7614 75.7614 93 73 93H11C8.23857 93 6 90.7614 6 88V5Z",
    fill: "#EDEDED"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_459_287",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 0,
    width: 72,
    height: 93
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 5C6 2.23858 8.23858 0 11 0H42.931H48.1285C49.4691 0 50.7535 0.538347 51.6935 1.4942L64.0345 14.0436L76.5256 26.4651C77.4694 27.4035 78 28.6795 78 30.0105V55.8624V88C78 90.7614 75.7614 93 73 93H11C8.23857 93 6 90.7614 6 88V5Z",
    fill: "#EDEDED"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_459_287)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: -29,
    width: 56,
    height: 56,
    fill: "#D9D9D9"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 67,
    width: 48,
    height: 20,
    rx: 3,
    fill: "#2BC54D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2614 72.3182L15.1207 75.5348H15.2003L17.0795 72.3182H19.8338L16.7614 77.4091L19.9332 82.5H17.1094L15.2003 79.2486H15.1207L13.2116 82.5H10.4077L13.5646 77.4091L10.4872 72.3182H13.2614ZM21.1065 82.5V72.3182H23.5675V80.5014H27.8033V82.5H21.1065ZM34.5808 75.3707C34.5476 75.0062 34.4002 74.7228 34.1383 74.5206C33.8798 74.3151 33.5102 74.2124 33.0297 74.2124C32.7115 74.2124 32.4463 74.2538 32.2342 74.3366C32.0221 74.4195 31.863 74.5339 31.7569 74.6797C31.6509 74.8222 31.5962 74.9863 31.5929 75.1719C31.5862 75.3243 31.6161 75.4586 31.6824 75.5746C31.752 75.6906 31.8514 75.7933 31.9806 75.8828C32.1132 75.969 32.2723 76.0452 32.4579 76.1115C32.6435 76.1778 32.8523 76.2358 33.0843 76.2855L33.9593 76.4844C34.4631 76.5938 34.9073 76.7396 35.2917 76.9219C35.6795 77.1042 36.0043 77.3213 36.2662 77.5732C36.5313 77.825 36.7318 78.1151 36.8677 78.4432C37.0036 78.7713 37.0732 79.1392 37.0765 79.5469C37.0732 80.1899 36.9108 80.7417 36.5893 81.2024C36.2678 81.6631 35.8055 82.0161 35.2022 82.2614C34.6023 82.5066 33.8781 82.6293 33.0297 82.6293C32.1779 82.6293 31.4354 82.5017 30.8024 82.2464C30.1693 81.9912 29.6771 81.6035 29.3258 81.0831C28.9745 80.5627 28.7939 79.9048 28.7839 79.1094H31.1404C31.1603 79.4375 31.2482 79.7109 31.4039 79.9297C31.5597 80.1484 31.7735 80.3142 32.0453 80.4268C32.3204 80.5395 32.6386 80.5959 32.9998 80.5959C33.3313 80.5959 33.613 80.5511 33.845 80.4616C34.0803 80.3722 34.2609 80.2479 34.3869 80.0888C34.5128 79.9297 34.5775 79.7474 34.5808 79.5419C34.5775 79.3497 34.5178 79.1856 34.4018 79.0497C34.2858 78.9105 34.1068 78.7912 33.8649 78.6918C33.6262 78.589 33.3213 78.4946 32.9501 78.4084L31.8862 78.1598C31.0046 77.9576 30.3102 77.6312 29.8031 77.1804C29.296 76.7263 29.0441 76.1132 29.0474 75.3409C29.0441 74.7112 29.2131 74.1593 29.5545 73.6854C29.8959 73.2114 30.3682 72.8419 30.9714 72.5767C31.5746 72.3116 32.2624 72.179 33.0346 72.179C33.8234 72.179 34.5079 72.3132 35.0879 72.5817C35.6712 72.8468 36.1236 73.2197 36.4451 73.7003C36.7666 74.1809 36.9307 74.7377 36.9373 75.3707H34.5808Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 33,
    width: 16,
    height: 7,
    fill: "#2BC54D"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 44,
    width: 16,
    height: 7,
    fill: "#2BC54D"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 55,
    width: 16,
    height: 7,
    fill: "#2BC54D"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 33,
    width: 16,
    height: 7,
    fill: "#2BC54D"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 44,
    width: 16,
    height: 7,
    fill: "#2BC54D"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 55,
    width: 16,
    height: 7,
    fill: "#2BC54D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoXls);
export default __webpack_public_path__ + "static/media/ico_xls.b4ea22d5a4a6bfe943a47f25432c0b24.svg";
export { ForwardRef as ReactComponent };